import dayjs from 'dayjs'

import 'dayjs/locale/it'
import duration from 'dayjs/plugin/duration'

export function secondsToDuration(seconds?: number | null): string | null {
  if (!Boolean(seconds) || Boolean(seconds < 60)) {
    return null
  }

  dayjs.extend(duration)

  const formatted = dayjs.duration(seconds, 'seconds').locale('it')
  const totHoursDisplay =
    formatted.asHours() >= 1 ? `${Math.floor(formatted.asHours())} H ` : ''
  const totMinutesDisplay =
    formatted.minutes() > 0 ? `${formatted.minutes()} MIN` : ''

  return `${totHoursDisplay}${totMinutesDisplay}`
}
